import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {IPolyBetLineConfig, IPolyBetLineStyle, PolyBetLine} from "@nolimitcity/slot-game/bin/game/betline/line/PolyBetLine";
import {CreepyCarnivalTwoGameConfig} from "../../CreepyCarnivalTwoGameConfig";
import {CCTwoHelper} from "../../utils/CCTwoHelper";

export interface ICCTWoPolyBetLineConfig extends IPolyBetLineConfig {
    readonly freeSpinStyles:IPolyBetLineStyle[];

}

export class CCTwoPolyBetLine extends PolyBetLine {
    private _reelAreaMask:PIXI.Graphics | PIXI.Sprite;

    constructor(index:number, numberPosition:number[], betLineData:number[], config:ICCTWoPolyBetLineConfig) {
        super(index, numberPosition, betLineData, config);
        this.drawMask();
    }

    protected draw(numberPosition:number[], betLineData:number[], config:ICCTWoPolyBetLineConfig):void {
        const linePositions:number[][] = [];
        let yPosition:number = 0,
            gapBetweenReels = CreepyCarnivalTwoGameConfig.instance.REEL_DISPLAY_POSITIONS[3][0] - CreepyCarnivalTwoGameConfig.instance.REEL_DISPLAY_POSITIONS[1][0] - CreepyCarnivalTwoGameConfig.instance.SYMBOL_WIDTH;

        if(numberPosition[2] === 0) {
            for(let j:number = 0; j < betLineData.length; j++) {
                const symId:number = betLineData[j];
                const basePosition:number[] = CCTwoHelper.getSymbolPositions(j, symId);
                //fetching yPosition so that the end of the line could be straight
                yPosition = basePosition[1];
                break;
            }
            linePositions.push([275, numberPosition[1]]);
        } else {
            for(let j:number = 0; j < betLineData.length; j++) {
                const symId:number = betLineData[j];
                const basePosition:number[] = CCTwoHelper.getSymbolPositions(j, symId);
                yPosition = basePosition[1];
                break;
            }
            linePositions.push([275, yPosition]);
        }

        for(let j:number = 0; j < betLineData.length; j++) {
            const symId:number = betLineData[j];
            const basePosition:number[] = CCTwoHelper.getSymbolPositions(j, symId);
            basePosition[0] += gapBetweenReels;
            linePositions.push(basePosition);
        }
        if(numberPosition[2] === 0) {
            linePositions.push([1025, yPosition]);
        } else {
            linePositions.push([numberPosition[0], numberPosition[1]]);
        }

        // Draw the line.
        let line:PIXI.Graphics | null = new PIXI.Graphics();
        let lineWidth:number = 0;

        for(let i:number = 0; i < config.styles.length; i++) {
            const betLineNum = CreepyCarnivalTwoGameConfig.instance.BETLINES.indexOf(this.index);
            if(betLineNum % 2 !== 0) {

                this.drawPolylineCCTwo(line, linePositions, config.styles[i]);
            } else {

                this.drawPolylineCCTwo(line, linePositions, config.freeSpinStyles[i]);
            }
            lineWidth = Math.max(lineWidth, config.styles[i].lineWidth);
        }

        this.addChild(line);

        StageManager.getLayer(config.staticLineLayer).addChild(this);
        this.alpha = 0;
    }

    /**
     * @description: to mask the betlines from end to end of the visible reel symbols
     */
    private drawMask():void {
        const rect = GameConfig.instance.REEL_AREA_MASK_RECT != undefined ? GameConfig.instance.REEL_AREA_MASK_RECT :
            new PIXI.Rectangle(GameConfig.instance.REEL_AREA_POS_X, GameConfig.instance.REEL_AREA_POS_Y, GameConfig.instance.REEL_AREA_WIDTH, GameConfig.instance.REEL_AREA_HEIGHT);
        const maskShape = new PIXI.Graphics();
        maskShape.beginFill(0xFFFFFF, 1);
        maskShape.drawRect(rect.x + 72, rect.y, rect.width - 145, rect.height);
        maskShape.endFill();
        if(this._reelAreaMask != null) {
            this.removeChild(this._reelAreaMask);
        }
        this._reelAreaMask = maskShape;
        this.addChild(this._reelAreaMask);
        this.mask = this._reelAreaMask;
    }

    private drawPolylineCCTwo(line:PIXI.Graphics, points:number[][], style:IPolyBetLineStyle):void {
        line.lineStyle(style.lineWidth, style.color, style.alpha);
        line.moveTo(points[0][0], points[0][1]);
        for(let i:number = 1; i < points.length; i++) {
            line.lineTo(points[i][0], points[i][1]);
        }
    }

    private getHighestPointYCCTwo(points:number[][]):number {
        let y:number = points[0][1];
        for(let i:number = 1; i < points.length; i++) {
            y = Math.min(y, points[i][1]);
        }

        return y;
    }

}